<template>
  <div class="cmp tab2_dypj">
    <div class="tabs">
      <!-- 切换 班级 -->
      <template v-if="(userInfo.type === 'TEACHER' || userInfo.type === 'SCHOOL_MANAGER') && classList.length">
        <p
          :class="{ bg: item.id === currentClassId }"
          v-for="(item, index) in classList"
          :key="index"
          @click="switchClassChange(item)"
        >
          {{ item.gradeName + "-" + item.name }}
        </p>
      </template>
      <img class="refresh" @click="refreshChange" src="@/assets/images/onlinecourses/refresh.png" alt="" />
    </div>
    <div class="question_tips" v-if="userInfo.type === 'TEACHER'">
      <p class="question_total">
        当前学生：{{ ((taskEvaluateData[currentStatus] || {})[currentStudentIndex] || {}).userName }}
      </p>
    </div>
    <div class="TASK_evaluate_body evaluate_body">
      <div class="UNIT_tabs" v-if="data.evaluate.type === 'UNIT'">
        <p
          @click="currentEvaluateTypeChange(v)"
          :class="{ bg: currentEvaluateType === v.type }"
          v-for="(v, i) in evaluateTypeList[userInfo.type]"
          :key="i"
        >
          {{ v.name }}
        </p>
      </div>

      <section style="display: flex;">
        <ul v-if="data.evaluate.type === 'TASK'">
          <li v-for="(item, index) in taskEvaluateData.questions" :key="index">
            <div>
              <span>第{{ index + 1 }}项</span>
              <el-rate v-if="TASKrateFlag" v-model="item.evaluateStar"></el-rate>

              <el-rate disabled v-else :value="formatEvaluateStar(item)"></el-rate>
            </div>
            <p style="white-space:pre-line">{{ item.content }}</p>
          </li>

          <div class="btn" v-if="userInfo.type === 'STUDENT'">
            <el-button type="primary" :disabled="taskEvaluateData.flag" size="small" @click="submitEvaluateChange"
              >保存</el-button
            >
          </div>
        </ul>

        <ul v-if="data.evaluate.type === 'UNIT'">
          <li class="peer_assessment" v-if="currentEvaluateType === 'CLASSMATE'">
            <div class="header">
              <h3>为我评价的同学</h3>
              <p>
                每人最多可收获 <i>{{ taskEvaluateData.evaluators }}</i> 名同伴评价
              </p>
            </div>
            <div class="userNameList">
              <p
                :class="['text-ellipsis', { bg: evaluateMeIndex === i }]"
                v-for="(v, i) in taskEvaluateData.finish"
                @click="evaluateMeChange(i)"
                :key="i"
              >
                {{ v.userName }}
              </p>
            </div>
          </li>

          <section>
            <li v-for="(item, index) in taskEvaluateData.questions" :key="index">
              <div>
                <span>第{{ index + 1 }}项</span>
                <el-rate v-if="UNITrateFlag" v-model="item.evaluateStar"></el-rate>
                <el-rate disabled v-else :value="formatEvaluateStar(item)"></el-rate>
              </div>
              <p style="white-space:pre-line">{{ item.content }}</p>
            </li>
          </section>

          <div class="btn">
            <el-button type="primary" :disabled="UNITsubmitEvaluateFlag" size="small" @click="submitEvaluateChange"
              >保存</el-button
            >
          </div>
        </ul>

        <div class="right" v-if="userInfo.type !== 'STUDENT'">
          <div class="right_header">
            <el-tabs class="right_tabs" v-model="currentStatus" @tab-click="userTabsChange">
              <el-tab-pane :label="`已完成（${(taskEvaluateData.finish || []).length}）`" name="finish">
                <div class="userNameList">
                  <p
                    :class="['text-ellipsis', { bg: currentStudentIndex === i }]"
                    v-for="(v, i) in taskEvaluateData.finish"
                    @click="currentStudentChange(i)"
                    :key="i"
                  >
                    {{ v.userName }}
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="`未完成（${(taskEvaluateData.unFinish || []).length}）`" name="unFinish">
                <div class="userNameList">
                  <p
                    :class="['text-ellipsis', { bg: currentStudentIndex === i }]"
                    v-for="(v, i) in taskEvaluateData.unFinish"
                    @click="currentStudentChange(i)"
                    :key="i"
                  >
                    {{ v.userName }}
                  </p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="CLASSMATE_right" v-if="userInfo.type === 'STUDENT' && currentEvaluateType === 'CLASSMATE'">
          <div class="right_header">
            <p>我给他们评价</p>
            <div class="userNameList">
              <p
                :class="['text-ellipsis', { bg: evaluateHeIndex === i }, { disabled: v.flag }]"
                v-for="(v, i) in taskEvaluateData.classDetails"
                @click="evaluateHeChange(i, v)"
                :key="i"
              >
                {{ v.userName }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import publicUrl from "@/assets/js/interface";
export default {
  name: "tab2_dypj",
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      evaluateMeIndex: -1, // 为我评价的同学下标
      evaluateHeIndex: -1, // 我给他们评价
      currentEvaluateType: "SELF",
      evaluateTypeList: {
        STUDENT: [
          { name: "自我评价", type: "SELF" },
          { name: "同伴评价", type: "CLASSMATE" },
          { name: "教师评价", type: "TEACHER" },
        ],
        TEACHER: [
          { name: "自我评价", type: "SELF" },
          { name: "教师评价", type: "TEACHER" },
        ],
        SCHOOL_MANAGER: [
          { name: "自我评价", type: "SELF" },
          { name: "教师评价", type: "TEACHER" },
        ],
      },

      currentStatus: "finish", // 当前评价筛选的学生类型
      currentStudentIndex: 0,
      classList: [],
      currentClassId: null,
      taskEvaluateData: {},
    };
  },
  computed: {
    ...mapState(["userInfo", "userAvatarDict", "messageParams"]),
    ...mapGetters({
      classActive: "classmanagement/classActive",
    }),
    // 任务评价 - 选择星星flag
    TASKrateFlag() {
      if (this.userInfo.type === "STUDENT") {
        return !this.taskEvaluateData.flag;
      } else {
        return false;
      }
    },
    UNITrateFlag() {
      // 单元评价 - 选择星星flag
      // 自我评价
      if (this.currentEvaluateType === "SELF") {
        // 老师
        if (this.userInfo.type === "TEACHER") {
          return false;
          // 其他
        } else if (this.userInfo.type === "STUDENT") {
          return this.taskEvaluateData.flag ? false : true;
        } else {
          return false;
        } // 教师评价
      } else if (this.currentEvaluateType === "TEACHER") {
        // 老师
        if (this.userInfo.type === "TEACHER") {
          return this.currentStatus === "unFinish" && (this.taskEvaluateData.unFinish || []).length;
          // 其他
        } else if (this.userInfo.type === "STUDENT") {
          return false;
        } else {
          return false;
        }
      } else if (this.currentEvaluateType === "CLASSMATE") {
        // 为我评价的同学
        if (this.evaluateMeIndex >= 0) {
          return false;
        } else if (this.evaluateHeIndex >= 0) {
          // 我给他们评价
          return true;
        }
      }
      return true;
    },
    UNITsubmitEvaluateFlag() {
      // 单元评价 - 保存评价flag
      let flag = null;

      if (this.currentEvaluateType === "SELF") {
        flag = this.taskEvaluateData.flag;
      } else if (this.currentEvaluateType === "CLASSMATE") {
        flag = false;
      } else if (this.currentEvaluateType === "TEACHER") {
        if (this.currentStatus !== "unFinish") {
          flag = true;
        } else {
          flag = (this.taskEvaluateData || {}).unFinish.length ? false : true;
        }

        if (this.userInfo.type === "SCHOOL_MANAGER") {
          // 校管不允许保存评价
          flag = true;
        }
      }
      return flag;
    },
  },
  watch: {
    data: {
      handler() {
        // 切换评价类型初始化
        this.currentStatus = "finish"; // 当前评价筛选的学生类型
        this.currentStudentIndex = 0;
        this.init();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations(["setMessageParams"]),
    initMessageInfo() {
      let messageParams = JSON.parse(JSON.stringify(this.messageParams));
      this.setMessageParams();
      if (messageParams.messageType === "EVALUATE") {
        this.taskEvaluateData.finish &&
          this.taskEvaluateData.finish.forEach((v, i) => {
            if (v.id === Number(messageParams.userId)) {
              this.userInfo.type === "TEACHER" ? (this.currentStudentIndex = i) : (this.evaluateMeIndex = i);
            }
          });
      }
    },
    evaluateHeChange(i, v) {
      // 我给他们评价切换
      if (v.flag) return false;
      this.evaluateHeIndex = i;
      this.evaluateMeIndex = -1;
    },
    evaluateMeChange(i) {
      // 为我评价的同学切换
      this.evaluateMeIndex = i;
      this.evaluateHeIndex = -1;
    },

    // 切换评价类型（自我评价-同伴评价-教师评价）
    currentEvaluateTypeChange(item) {
      this.currentEvaluateType = item.type;
      this.currentStatus = "finish"; // 切换评价类型-重置当前评价筛选的类型（未完成，已完成）

      // 切换
      if (this.currentEvaluateType === "CLASSMATE") {
        this.currentStudentIndex = 1; // 切换评价类型-重置选择学生下标
      } else {
        this.evaluateMeIndex = -1; // 重置同伴评价俩开关
        this.evaluateHeIndex = -1; // 重置同伴评价俩开关
        this.currentStudentIndex = 0; // 切换评价类型-重置选择学生下标
      }
      this.getTaskEvaluateList();
    },
    // 筛选当前选择用户的数据
    getScreenUserData(item, id, key) {
      if (!item.details.length) return 0;
      let userData = {
        evaluateStar: 0,
      };
      item.details &&
        item.details.forEach((v) => {
          if (v[key] === id) {
            userData = v;
          }
        });

      return userData;
    },
    // 计算不能选择时候各个状态的星星
    formatEvaluateStar(item) {
      let evaluateStar = 0;
      // 区分单元评价还是任务评价
      if (this.data.evaluate.type === "TASK") {
        if (this.userInfo.type === "STUDENT") {
          evaluateStar = item.details[0].evaluateStar;
        } else if (this.userInfo.type === "TEACHER" || this.userInfo.type === "SCHOOL_MANAGER") {
          if (this.taskEvaluateData[this.currentStatus].length && this.currentStatus === "finish") {
            evaluateStar =
              this.getScreenUserData(
                item,
                this.taskEvaluateData[this.currentStatus][this.currentStudentIndex].id,
                "userId"
              ).evaluateStar || 0;
          } else {
            evaluateStar = 0;
          }
        } else {
          evaluateStar = 0;
        }
      } else {
        // 单元
        if (this.currentEvaluateType === "SELF") {
          // 老师
          if (this.userInfo.type === "TEACHER" || this.userInfo.type === "SCHOOL_MANAGER") {
            if (this.taskEvaluateData[this.currentStatus].length && this.currentStatus === "finish") {
              evaluateStar =
                this.getScreenUserData(
                  item,
                  this.taskEvaluateData[this.currentStatus][this.currentStudentIndex].id,
                  "userId"
                ).evaluateStar || 0;
            } else {
              evaluateStar = 0;
            }
          } else if (this.userInfo.type === "STUDENT") {
            evaluateStar = item.details[0].evaluateStar;
          } else {
            // 其他
            evaluateStar = 0;
          }
        } else if (this.currentEvaluateType === "TEACHER") {
          // 老师
          if (this.userInfo.type === "TEACHER" || this.userInfo.type === "SCHOOL_MANAGER") {
            if (this.taskEvaluateData[this.currentStatus].length && this.currentStatus === "finish") {
              evaluateStar =
                this.getScreenUserData(
                  item,
                  this.taskEvaluateData[this.currentStatus][this.currentStudentIndex].id,
                  "userId"
                ).evaluateStar || 0;
            } else {
              evaluateStar = 0;
            }

            // 其他
          } else if (this.userInfo.type === "STUDENT") {
            evaluateStar = (item.details[0] || {}).evaluateStar || 0;
          } else {
            evaluateStar = 0;
          }
        } else if (this.currentEvaluateType === "CLASSMATE") {
          // 为我评价的同学
          if (this.evaluateMeIndex >= 0) {
            evaluateStar =
              this.getScreenUserData(item, this.taskEvaluateData.finish[this.evaluateMeIndex].id, "createUser")
                .evaluateStar || 0;
          } else if (this.evaluateHeIndex >= 0) {
            // 我给他们评价
            evaluateStar = 0;
          }
        }
      }
      return Number(evaluateStar || 0);
    },
    // 切换已完成 未完成状态
    userTabsChange(tab) {
      this.currentStatus = tab.name;
      this.currentStudentIndex = 0;
    },
    // 教师选择学生
    currentStudentChange(index) {
      this.currentStudentIndex = index;
    },
    // 保存提交评价
    submitEvaluateChange() {
      if (!this.taskEvaluateData.questions.length) return false;
      if (this.currentEvaluateType === "CLASSMATE" && this.evaluateHeIndex < 0) {
        this.$message.error("请选择给哪位同学进行评价");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        details: [],
        subType: this.data.evaluate.type === "TASK" ? "SELF" : this.currentEvaluateType,
        taskModelId: this.data.id,
        beEvaluatedUser:
          this.currentEvaluateType === "SELF"
            ? this.userInfo.id
            : this.currentEvaluateType === "TEACHER"
            ? this.taskEvaluateData.unFinish[this.currentStudentIndex].id
            : this.taskEvaluateData.classDetails[this.evaluateHeIndex].id,
      };
      this.taskEvaluateData.questions &&
        this.taskEvaluateData.questions.forEach((v) => {
          params.details.push({
            evaluateStar: v.evaluateStar,
            id: v.id,
          });
        });

      this.$ajaxJson
        .post(publicUrl.evaluateSubmit, {
          ...params,
        })
        .then((res) => {
          this.$ajaxCheck(res);
          this.init();
          if (this.currentEvaluateType === "CLASSMATE") {
            //如果是同伴评价保存 将同伴下标回复默认值
            this.evaluateHeIndex = -1;
            return false;
          }
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    // 切换班级
    switchClassChange(item) {
      this.currentClassId = item.id;
      this.getTaskEvaluateList();
    },

    // 刷新按钮操作
    refreshChange() {
      this.getTaskEvaluateList();
    },
    init() {
      // TEACHER("教师"), STUDENT("学生"), SCHOOL_MANAGER("校管"),
      // REDACT("编辑老师"), REVIEW_REDACT("审核编辑"), FINAL_REDACT("审核负责人");

      if (isNaN(parseInt(this.data.id))) return;
      // 教师请求学生列表
      if (this.userInfo.type === "STUDENT") {
        let messageParams = JSON.parse(JSON.stringify(this.messageParams));
        if (messageParams.grandType) {
          this.currentEvaluateTypeChange({ type: messageParams.grandType });
        } else {
          this.getTaskEvaluateList();
        }
      } else if (this.userInfo.type === "TEACHER" || this.userInfo.type === "SCHOOL_MANAGER") {
        this.getAddStudentClassList();
      }
    },
    // 查询班级
    getAddStudentClassList() {
      let _this = this;
      _this.classList = [];
      // 查询年级班级列表
      this.$ajax
        .get(publicUrl.bookBindClass, {
          params: {
            bookId: this.$route.query.id,
          },
        })
        .then((res) => {
          let data = _this.$ajaxCheck(res);
          function deepFn(arr) {
            if (!arr.length) return false;
            arr &&
              arr.forEach((item) => {
                if (item.classes) {
                  deepFn(item.classes);
                } else {
                  _this.classList.push(item);
                }
              });
          }

          deepFn(data);
          this.$nextTick(() => {
            if (_this.classList.length) {
              this.currentClassId = _this.classList[0].id;
            }
            this.getTaskEvaluateList();
          });
        })
        .catch((err) => {
          this.$ajaxError(err);
        });
    },
    // 查询评价详情
    getTaskEvaluateList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$ajax
        .get(publicUrl.taskEvaluateList, {
          params: {
            classId: this.userInfo.type === "STUDENT" ? this.userInfo.classId : this.currentClassId,
            modelChildId: this.data.modelChildId,
            //任务评价默认SELF
            evaluateSource: this.data.evaluate.type === "TASK" ? "SELF" : this.currentEvaluateType,
          },
        })
        .then((res) => {
          let data = this.$ajaxCheck(res);
          this.taskEvaluateData = data;
          this.taskEvaluateData.questions &&
            this.taskEvaluateData.questions.forEach((v) => {
              this.$set(v, "evaluateStar", 0);
            });

          this.$nextTick(() => {
            this.initMessageInfo(); // 初始化消息列表跳过来的数据
          });
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.tab2_dypj {
  background-image: linear-gradient(#ecf5fb, #ffffff);
  margin-bottom: 20px;
  height: 100%;
  min-height: 800px;
  .tabs {
    padding: 16px 0;
    margin: 0 30px;
    position: relative;
    display: flex;
    p {
      margin-right: 20px;
    }
    .refresh {
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
    .bg {
      color: #19a4ff;
    }
    p {
      &:hover {
        cursor: pointer;
        color: #19a4ff;
      }
    }
  }
  .question_tips {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 0 42px 0px 42px;
    .question_total {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 22px;
      position: relative;
      margin: 20px 0;

      &::before {
        position: absolute;
        content: "";
        width: 2px;
        height: 16px;
        background: #19a4ff;
        border-radius: 1px;
        left: -12px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        color: #19a4ff;
        margin-right: 10px;
      }
    }
  }
  .evaluate_body {
    .UNIT_tabs {
      display: flex;
      padding: 0 30px;

      p {
        width: 82px;
        height: 36px;
        text-align: center;
        margin-right: 20px;
        line-height: 36px;
        cursor: pointer;
        border-radius: 5px;
        &.bg {
          background: #19a4ff;
          color: #fff;
        }
      }
    }
    ul {
      width: 100%;
      .btn {
        margin: 10px 30px;
        display: flex;
        justify-content: flex-end;
      }
      li {
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #d0d6da;
        background: #fff;
        margin: 10px 30px;
        padding: 14px 20px;
        > div {
          display: flex;
          > span {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            margin-right: 10px;
            color: #19a4ff;
          }
        }
        > p {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-top: 11px;
        }
      }
    }
    .right {
      width: 310px;
      height: 370px;
      background: #ffffff;
      border-radius: 6px;
      margin: 10px 30px 0 0;
      border: 1px solid #d0d6da;
      .right_header {
        display: flex;
        justify-content: center;
        .right_tabs {
          width: 100%;
        }
      }
    }
    .CLASSMATE_right {
      width: 310px;
      height: 370px;
      background: #ffffff;
      border-radius: 6px;
      margin: 10px 30px 0 0;
      border: 1px solid #d0d6da;
      .right_header {
        > p {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          padding: 10px;
          border-bottom: 1px solid #d0d6da;
        }
      }
    }
    .peer_assessment {
      .header {
        display: flex;
        align-items: center;
        h3 {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-right: 10px;
        }
        > p {
          width: 160px;
          height: 17px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 17px;
          > i {
            color: #19a4ff;
          }
        }
      }
      .userNameList {
        padding: 0;
      }
    }
  }
}
/deep/.el-tabs__header {
  display: flex;
  justify-content: center;
}
.userNameList {
  display: flex;
  flex-wrap: wrap;
  padding: 0 8px;
  flex-basis: 20%;
  p {
    height: 26px;
    width: 4em;
    margin: 5px;
    text-align: center;
    line-height: 26px;
    cursor: pointer;

    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    &.disabled {
      cursor: no-drop;
      color: #999999 !important;
      background: #f0f2f5 !important;
      border: 1px solid transparent !important;
    }
    &.bg {
      width: 56px;
      color: #ffffff;
      height: 26px;
      background: #19a4ff;
      border-radius: 6px;
      border: 1px solid #19a4ff;
    }
  }
}
</style>
